import React, { useEffect, useState } from "react";
import AtrDataList from "./AtrDataList";
import AttriContent from "./AttriContent";
import { fetchQCList } from "../../Redux/features/QCList/qcListSlice";
import { useDispatch } from "react-redux";
import { useAuthDetails } from "../../Common/cookiesHelper";

const MainCategory = () => {
  const dispatch = useDispatch();
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const [visible, seVisible] = useState("AtrDataList");
  useEffect(() => {
    if (!userTypeData?.token) return;
    dispatch(
      fetchQCList({
        merchant_id,
        ...userTypeData,
      }),
    );
  }, []);

  return (
    <>
      <div className="q-attributes-main-page">
        <AttriContent />
        {visible === "AtrDataList" && <AtrDataList seVisible={seVisible} />}
      </div>
    </>
  );
};

export default MainCategory;
